import { API } from './api';
import { StaticContentInterface } from '../interfaces/StaticContentInterface';
import { UpdateStaticContentDto } from "../interfaces/UpdateStaticContentDto";
import { CreateStaticContentDto } from "../interfaces/CreateStaticContentDto";

export class StaticContentManager {
  static getAll(): Promise<StaticContentInterface[]> {
    return API.get('admin/staticContent');
  }
  static getOne(id: string) {
    return API.get(`admin/staticContent/${id}`);
  }
  static create(staticContent: CreateStaticContentDto) {
    return API.post('admin/staticContent', staticContent);
  }
  static update(id: string, updateDto: UpdateStaticContentDto) {
    return API.patch(`admin/staticContent/${id}`, updateDto);
  }
  static delete(name: string) {
    return API.delete(`admin/staticContent/${name}`);
  }
}

export default StaticContentManager;
